/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offers_Made_To_OrderInputs */

const en_offers_made_to_order = /** @type {(inputs: Offers_Made_To_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for you after you buy it`)
};

const pl_offers_made_to_order = /** @type {(inputs: Offers_Made_To_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przygotowany dla Ciebie po zakupie`)
};

/**
* | output |
* | --- |
* | "Built for you after you buy it" |
*
* @param {Offers_Made_To_OrderInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offers_made_to_order = /** @type {((inputs?: Offers_Made_To_OrderInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offers_Made_To_OrderInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offers_made_to_order(inputs)
	return en_offers_made_to_order(inputs)
});